import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const Footer = () => (
  <footer className="bg-white border-t border-[#E4DFD8] py-14">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <div className="flex flex-col md:flex-row justify-between items-center gap-8">
        <div className="flex items-center gap-3">
          <div className="w-7 h-7 rounded-lg bg-[#1A1A18] flex items-center justify-center flex-shrink-0">
            <SafeIcon icon={FiIcons.FiZap} className="text-[#F7F5F2] text-xs" />
          </div>
          <span className="text-base font-bold text-[#1A1A18]">WeekOne Systems</span>
        </div>
        <div className="flex gap-8">
          {['Privacy Policy', 'Terms of Service', 'Contact Support'].map((link) => (
            <a key={link} href="#" className="text-[#9E9690] hover:text-[#1A1A18] transition-colors font-mono-custom text-[11px] uppercase tracking-wider">
              {link}
            </a>
          ))}
        </div>
      </div>

      <div className="mt-10 pt-8 border-t border-[#EDE9E4]">
        <div className="text-center mb-5">
          <p className="text-sm font-semibold text-[#1A1A18] mb-1">The infrastructure company underneath.</p>
          <p className="text-xs text-[#9E9690] max-w-md mx-auto leading-relaxed">
            Your personal assistant is the beginning. CRM, dashboards, and automation architecture are what we build next.
          </p>
        </div>
        <div className="flex flex-col sm:flex-row justify-between items-center gap-2">
          <p className="text-xs text-[#9E9690] font-mono-custom">© 2026 WeekOne Systems, a CHRSMA company.</p>
          <p className="text-xs text-[#9E9690] font-mono-custom">Powered by OpenClaw · Built for operators</p>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;